import CanIUse from "../../../../content/components/CanIUse";
import GSCFirstExample from "../../../../content/blog/general-sibling-combinator/Examples/GSCFirstExample";
import GSCSecondExample from "../../../../content/blog/general-sibling-combinator/Examples/GSCSecondExample";
import * as React from 'react';
export default {
  CanIUse,
  GSCFirstExample,
  GSCSecondExample,
  React
};